import useAuth from '../../auth/useAuth';
import useSubscription from '../../subscription/hooks/useSubscription';

import { useAppDispatch } from '../../../App/redux/store';
import Button from '../../../components/Assets/Button';
import { APIStatus } from '../../../services/axiosEnums';
import { modalsActions } from '../../modals/modalsSlice';
import useUsers from '../useUsers';

const AddUserButton = () => {
  const { isManager } = useAuth({});
  const { totalAuthorizedUsers, subscriptionStatus } = useSubscription();
  const { userCount } = useUsers();

  const dispatch = useAppDispatch();

  const disabled =
    subscriptionStatus !== APIStatus.IDLE
      ? false
      : totalAuthorizedUsers <= userCount + 1;

  if (!isManager) return null;

  return (
    <Button
      btnType="button"
      btnContent={disabled ? 'MAX COLLABORATEUR ATTEINT' : 'AJOUTER COLLABORATEUR'}
      tooltipContent={`Nombre d'utilisateurs : ${userCount}/${totalAuthorizedUsers}`}
      handleClick={() =>
        dispatch(modalsActions.createOrUpdateUser({ open: true, entity: null }))
      }
      disabled={disabled}
      primary
    />
  );
};

export default AddUserButton;
